var map = {
	"./decidim/avatar-multiuser.png": 38610,
	"./decidim/brands/google.svg": 83987,
	"./decidim/cc-badge.png": 14883,
	"./decidim/decidim-logo.svg": 86508,
	"./decidim/default-avatar.svg": 41820,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 79201,
	"./decidim/icons.svg": 81015,
	"./decidim/pattern.png": 40048,
	"./decidim/placeholder.jpg": 18193,
	"./decidim/vendor/leaflet/layers-2x.png": 9141,
	"./decidim/vendor/leaflet/layers.png": 43257,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 88828,
	"./decidim/vendor/leaflet/marker-icon.png": 70758,
	"./decidim/vendor/leaflet/marker-shadow.png": 55357,
	"./decidim/vendor/social-share-button/delicious.svg": 27202,
	"./decidim/vendor/social-share-button/douban.svg": 88029,
	"./decidim/vendor/social-share-button/email.svg": 37456,
	"./decidim/vendor/social-share-button/facebook.svg": 65357,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 1497,
	"./decidim/vendor/social-share-button/google_plus.svg": 84987,
	"./decidim/vendor/social-share-button/hacker_news.svg": 27126,
	"./decidim/vendor/social-share-button/linkedin.svg": 27356,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 90621,
	"./decidim/vendor/social-share-button/pinterest.svg": 51317,
	"./decidim/vendor/social-share-button/qq.svg": 72024,
	"./decidim/vendor/social-share-button/reddit.svg": 70240,
	"./decidim/vendor/social-share-button/telegram.svg": 90827,
	"./decidim/vendor/social-share-button/tumblr.svg": 99548,
	"./decidim/vendor/social-share-button/twitter.svg": 48122,
	"./decidim/vendor/social-share-button/vkontakte.svg": 81080,
	"./decidim/vendor/social-share-button/wechat.svg": 57642,
	"./decidim/vendor/social-share-button/weibo.svg": 30616,
	"./decidim/vendor/social-share-button/whatsapp.svg": 57582,
	"./decidim/vendor/social-share-button/xing.svg": 33782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97870;